/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（月曜日）
 * @export
 * @interface EnableShipdayMon
 */
export interface EnableShipdayMon {
}

/**
 * Check if a given object implements the EnableShipdayMon interface.
 */
export function instanceOfEnableShipdayMon(value: object): value is EnableShipdayMon {
    return true;
}

export function EnableShipdayMonFromJSON(json: any): EnableShipdayMon {
    return EnableShipdayMonFromJSONTyped(json, false);
}

export function EnableShipdayMonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdayMon {
    return json;
}

export function EnableShipdayMonToJSON(json: any): EnableShipdayMon {
    return EnableShipdayMonToJSONTyped(json, false);
}

export function EnableShipdayMonToJSONTyped(value?: EnableShipdayMon | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

